import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/financial-documents/financial-document/:documentId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    documentId: string;
}
const mutationFn = ({ documentId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { documentId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteFinancialDocument };
